import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="relative rounded-3xl overflow-hidden mb-10 md:mb-12 mx-auto max-w-2xl">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20product%20collection%20flatlay%20with%20fashion%20lifestyle%20accessories%20watches%20sunglasses%20small%20leather%20goods%20and%20textile%20swatches%20arranged%20in%20a%20circular%20composition%20on%20a%20light%20cream%20linen%20surface%2C%20soft%20golden%20hour%20lighting%20from%20top%20right%2C%20cozy%20editorial%20aesthetic%2C%20harmonious%20warm%20neutral%20earth%20tones%2C%20professional%20catalog%20photography%20with%20rich%20texture%20detail&width=1400&height=700&seq=cta-v2-product&orientation=landscape"
            alt="OOPBuy Spreadsheet product collection"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-5">
          {t("cta.title")}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto mb-8 leading-relaxed">
          {t("cta.description")}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-10 py-4 bg-foreground-900 text-background-50 font-semibold rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-shopping-cart-line"></i>
            {t("cta.button")}
          </a>
          <Link
            to="/oopbuy-spreadsheet-complete-guide"
            className="inline-flex items-center justify-center gap-2 px-10 py-4 border-2 border-foreground-200 text-foreground-700 font-semibold rounded-full hover:bg-foreground-50 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-book-open-line"></i>
            {t("article.link")}
          </Link>
        </div>
      </div>
    </section>
  );
}